<template>
  <div
    v-if="Array.isArray(value) && value.length"
    class="infoBlock"
  >
    <div
      class="expandable"
      @click="toggleExpando"
    >
      <div
        :class="expandoClass"
        :data-automation="dataAutomation + '-count'"
      >
        {{ value.length }}
      </div>
      <div
        class="label"
        :data-automation="dataAutomation + '-label'"
      >
        {{ label }}
      </div>
    </div>
    <div
      v-if="expanded"
      class="distributionList"
      :data-automation="dataAutomation + '-packages'"
    >
      <div class="tableContainer">
        <table class="contentListing">
          <tbody
            v-for="(p, i) in packagesWithURLs()"
            :key="i"
          >
            <DistributionItem :pkg="p" />
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import DistributionItem from './DistributionItem'
import { mapGetters } from 'vuex'
import { serverPath } from '../../api/http-common'

export default {
  name: 'DistributionList',
  components: {
    DistributionItem,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    dataAutomation: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: function () {
    return {
      expanded: false,
    }
  },
  computed: {
    expandoClass: function () {
      return this.expanded ? 'expando expanded' : 'expando collapsed'
    },
    repoName: function () {
      return this.currentRepo.name
    },
    ...mapGetters([
      'currentRepo',
    ]),
  },
  watch: {
    value: function (value) {
      this.expanded = false
    },
  },
  methods: {
    toggleExpando: function (event) {
      this.expanded = !this.expanded
    },
    packagesWithURLs: function () {
      for (let i = 0; i < this.value.length; i++) {
        try {
          this.value[i].URL = `${serverPath()}${this.repoName}/latest/packages/${this.value[i].digests.sha256}/${this.value[i].filename}`
        } catch (e) {
          console.error(e)
          this.value[i].URL = ''
        }
      }
      return this.value
    },
  },
}

</script>
